import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = match[1];

    const referralCode = sessionStorage.getItem("pending_referral_code") || "";
    googleLogin(sessionId, referralCode)
      .then(() => {
        // Set location onboarding flag for new Google users
        localStorage.setItem("needs_location_onboarding", "true");
        const requestedRedirect = sessionStorage.getItem("post_auth_redirect") || "/explore";
        sessionStorage.removeItem("post_auth_redirect");
        sessionStorage.removeItem("pending_referral_code");
        const redirectTo = requestedRedirect.startsWith("/") && !requestedRedirect.startsWith("//")
          ? requestedRedirect
          : "/explore";
        navigate(redirectTo, { replace: true });
      })
      .catch(() => {
        sessionStorage.removeItem("pending_referral_code");
        navigate("/login?error=google_failed", { replace: true });
      });
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-3">
        <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" />
        <p className="text-sm text-muted-foreground">Signing in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
